import { Box, Button, HStack } from '@chakra-ui/react'
import StandardButton from 'components/buttons/StandardButton'
import { StickyFooter } from 'components/common/StickyFooter'
import CharlesMeta from 'components/meta/CharlesMeta'
import { AboutSection } from 'components/sections/AboutSection'
import AccordionNewSection from 'components/sections/AccordionNewSection'
import BuyNowSection, { infoItemsProps } from 'components/sections/BuyNowSection'
import { DrAlineQuote } from 'components/sections/DrQuotes/DrAlineQuote'
import MayAlsoInterestYouSection from 'components/sections/MayAlsoInterestYouSection'
import ProductBannerSection from 'components/sections/ProductBannerSection'
import ProductFormulaSection from 'components/sections/ProductFormulaSection'
import StepsToTreatment from 'components/sections/StepsToTreatment'
import { hairPlusSteps } from 'components/sections/StepsToTreatment/stepsToTreatmentData'
import { TestimoniesSection } from 'components/sections/TestimoniesSection'
import { Body1, Body2Strong, H5 } from 'components/typography'
import { MAIS_FERT_VARIANTS, MAIS_HAIR_VARIANTS, MAIS_LIB_VARIANTS } from 'constants/products/menPower'
import { LandingBasicLayout } from 'layouts/LadingLayout'
import { isEqual } from 'lodash'
import { useRouter } from 'next/router'
import { FC, useCallback, useEffect, useState } from 'react'
import {
  MEN_POWER_CHECKOUT_INITIAL_STEP,
  PhytoVariantData,
  resetCheckoutMenPowerState,
  setActiveVariantId
} from 'redux/slices/checkout-men-power-slice'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { hairPlusFaq } from 'utils/data/faq/hairPlusFaq'
import { hairPlusIngredients } from 'utils/data/ingredients/hairPlusIngredients'
import { hairPlusTestimonies } from 'utils/data/testimonies'

const infoItemsList = [
  {
    label: '3 meses',
    prevPrice: 239,
    price: MAIS_HAIR_VARIANTS[0].price,
    variantId: MAIS_HAIR_VARIANTS[0].variantId
  },
  {
    label: '6 meses',
    prevPrice: 479,
    price: MAIS_HAIR_VARIANTS[1].price,
    variantId: MAIS_HAIR_VARIANTS[1].variantId
  }
]
const HairPlusPage: FC = () => {
  return (
    <>
      <CharlesMeta
        data={{
          title: '+hair | Omens',
          description:
            'Uma mistura de 11 ingredientes fundamentais, como cobre, selênio, zinco e uma mistura de suporte vitamínico. Formulado por médicos para nutrir o couro cabeludo e o cabelo, além de biotina para apoiar o crescimento do cabelo existente.'
        }}
      />

      <LandingBasicLayout>
        <ProductBannerSection
          bgImage="/landings/products/sexual_health/mais-hair-hero.png"
          heading="+hair"
          subheading={[
            'Uma mistura de 11 ingredientes fundamentais, como biotina, cobre, selênio, zinco e um blend de suporte vitamínico. Formulado por médicos para nutrir o couro cabeludo e o cabelo e apoiar o crescimento do cabelo existente.',
            'Com ingredientes de eficácia comprovada cientificamente, promove melhora no cuidado do seu cabelo.'
          ]}
          bulletPoints={[
            {
              text: 'Laboratório certificado pela ANVISA'
            },
            {
              text: 'Desenvolvido por médicos'
            },
            {
              text: 'Eficácia comprovada'
            }
          ]}
          infoItemsList={infoItemsList}
        />

        <DrAlineQuote quoteText="Assim como as raízes de uma planta absorvem a água para florescer, a Biotina revitaliza a raiz dos cabelos, promovendo um crescimento forte e duradouro. Cabelos nutridos e vigorosos são um sinal visível de saúde e vitalidade interna." />

        <TestimoniesSection
          title="35 mil brasileiros escolhendo a Omens para cuidar da saúde"
          showGoogleApproved={false}
          showStars
          titleProps={{
            textAlign: 'left',
            maxW: '460px'
          }}
          titleContainerProps={{
            align: 'flex-start'
          }}
          testimonies={hairPlusTestimonies}
          variant="light"
        />

        <ProductFormulaSection
          items={hairPlusIngredients}
          description="O +hair é uma fórmula exclusiva Omens®, com 11 ingredientes cuidadosamente selecionados pelos nossos médicos dermatologistas, em um processo rigoroso guiado pela ciência."
        />

        <BuyNowSection
          title={
            <>
              Receba o +hair <br /> em casa
            </>
          }
          infoItems={infoItemsList}
        />

        <Box bg="alabaster">
          <AboutSection
            title="Devo tomar o +hair?"
            titleProps={{
              flex: 1
            }}
            contentContainerProps={{
              flex: 1
            }}
            content={[
              <H5 key="1">Abordagem polivalente</H5>,
              <Body1
                key="2"
                mb={{
                  base: '48px',
                  lg: '96px'
                }}
              >
                Nossa formulação objetiva a otimização da função natural do seu corpo, com compostos fitoterápicos,
                vitaminas e minerais que têm efeitos em diversos aspectos da sua saúde capilar. Essa combinação, nas
                proporções metodicamente pensadas pela nossa equipe médica, resulta em um produto com alto nível de
                sucesso, ao mesclar várias abordagens na melhoria da função capilar e de pele.
              </Body1>,
              <H5 key="3">Segurança</H5>,
              <Body1 key="4">
                O +hair é produzido em um laboratório certificado, com ingredientes comprovados, seguros e de qualidade.
                Nossa fórmula exclusiva já foi utilizada por milhares de brasileiros. Se você tem dúvidas sobre o
                tratamento ou suplementação ideal para o seu caso, marque uma consulta online com um de nossos médicos —
                é simples, rápido e oferecemos um excelente custo-benefício.
              </Body1>
            ]}
          />
        </Box>

        <StepsToTreatment title="Transparência" steps={hairPlusSteps} />

        <MayAlsoInterestYouSection cardsContents={alsoInterestYouSection} />

        <AccordionNewSection sections={hairPlusFaq} />

        <StickyFooter alwaysVisible>
          <FooterButtonsProducts />
        </StickyFooter>
      </LandingBasicLayout>
    </>
  )
}

export default HairPlusPage

export const FooterButtonsProducts: FC = () => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const { activeVariantId } = useAppSelector((state) => state.checkoutMenPower)
  const [itemsVariant, setItemsVariant] = useState<PhytoVariantData[]>([])
  const [activeItem, setActiveItem] = useState<infoItemsProps | null>(null)

  useEffect(() => {
    if (router.pathname === '/produtos/mais-fert') {
      setItemsVariant(MAIS_FERT_VARIANTS)
    } else if (router.pathname === '/produtos/mais-hair') {
      setItemsVariant(MAIS_HAIR_VARIANTS)
    } else if (router.pathname === '/produtos/mais-lib') {
      setItemsVariant(MAIS_LIB_VARIANTS)
    }
  }, [router.pathname])

  const handleVariantSelect = useCallback(
    (variantId: string | number) => {
      dispatch(setActiveVariantId(variantId))
    },
    [dispatch]
  )

  const handleNavigateCheckout = useCallback(() => {
    dispatch(resetCheckoutMenPowerState())
    dispatch(setActiveVariantId(activeVariantId))
    router.push(MEN_POWER_CHECKOUT_INITIAL_STEP)
  }, [dispatch, router, activeVariantId])

  const handleOnClickButton = (item: infoItemsProps) => {
    setActiveItem(item)
    handleVariantSelect(item?.variantId ?? '')
  }

  return (
    <HStack gap={4}>
      <StandardButton text="Comprar" px={6} onClick={handleNavigateCheckout} />
      {itemsVariant.map((variant) => {
        const isActive = isEqual(activeItem, variant)

        return (
          <Button
            key={variant.variantId}
            bg={isActive ? 'phthalo' : 'white'}
            color={isActive ? 'alabaster' : 'phthalo'}
            onClick={() => {
              handleOnClickButton(variant)
            }}
            _focus={{}}
            _hover={{}}
            w="fit-content"
            size="lg"
            shadow="none"
            gap={4}
            p={6}
            fontSize="14px"
          >
            <strong>{variant.amount > 1 ? `${variant.amount} meses` : '1 mês'}</strong>
            <strong>|</strong>
            <strong>R${variant.price}</strong>
          </Button>
        )
      })}
    </HStack>
  )
}
const alsoInterestYouSection = [
  {
    title: 'Consulta sobre queda de cabelo',
    description:
      'O aspecto do seu cabelo te preocupa ou pode melhorar? Marque uma conversa online com um dos nossos médicos dermatologistas!',
    href: '/consultar?origin=dermatology'
  },
  {
    title: 'O Blog da Omens',
    description: 'Leia todo o conteúdo publicado pelos nossos médicos especialistas no Blog da Omens!',
    href: '/blog'
  }
]
